import { BtcAddressFormat } from '@optimex-xyz/trade-wallet-sdk'

import { SUPPORTED_NETWORK } from '@/utils'

import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

const CURRENT_VERSION = 5 // bump this to reset setting in future

interface Settings {
  acceptedTerms: boolean
  setAcceptedTerms: (v: boolean) => void
  recentWallets: Record<SUPPORTED_NETWORK, string>
  setRecentWallet: (v: { network: SUPPORTED_NETWORK | string; wallet: string }) => void
  btcAddressType: BtcAddressFormat | null // if btc wallet has multi wallet type like phantom, select default one
  setBtcAddressType: (v: BtcAddressFormat) => void
}

const initializeData = {
  acceptedTerms: false,
  recentWallets: {} as Record<SUPPORTED_NETWORK, string>,
  btcAddressType: null,
}

export const useSettings = create<Settings>()(
  persist(
    (set) => ({
      ...initializeData,
      setAcceptedTerms: (acceptedTerms) => set({ acceptedTerms }),
      setBtcAddressType: (btcAddressType) => set({ btcAddressType }),
      setRecentWallet: ({ network, wallet }) =>
        set((state) => ({
          recentWallets: { ...state.recentWallets, [network]: wallet },
        })),
    }),
    {
      name: 'setting-store',
      version: CURRENT_VERSION,
      storage: createJSONStorage(() => localStorage),
      migrate: (persistedState: any, version) => {
        if ((version || 0) < CURRENT_VERSION) {
          return { ...persistedState, acceptedTerms: false }
        }
        return persistedState
      },
    }
  )
)
